import Footer from "../components/layouts/Footer"
import { Navbar } from "../components/layouts/Navbar"
import Home from "./home"
import Location from "./location"
import { Menu } from "./menu"

const Index = () => {
    return (
        <div className="h-screen w-screen ">
            <Navbar />
            <main className="mt-16">
                <div id="home">
                    <Home />
                </div>
                <div id="menu">
                    <Menu />
                </div>
                <div id="location">
                    <Location />
                </div>
                <div id="footer">
                    <Footer />
                </div>
            </main>
        </div>
    )
}

export default Index